export const getAbsolutePath = (path: string) => `${window.location.origin}/${path}`;
